import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpStatusCode,
} from '@angular/common/http';
import { catchError, EMPTY, empty, from, map, switchMap, throwError } from 'rxjs';
import { DashboardService } from '../services/dashboard.service';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService: AuthService = inject(AuthService);
  const accessToken = localStorage.getItem('accessToken') || ''; // Get the token

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return next(authReq).pipe(
    map((event) => {
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        authService.loginState$.next(new Date());
      }
      return throwError(() => error);
    }),
  );

  // return from(authService.getAccessToken()).pipe(
  //   switchMap((token) => {
  //     const authReq = req.clone({
  //       setHeaders: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     return next(authReq);
  //   }),
  //   catchError(() => {
  //     authService.login();
  //     return next(req);
  //   })
  // );

  // return next(req).pipe(
  //   catchError((error) => {
  //     authService.loginState$.next(new Date());
  //     throw error;
  //   }),
  // );
};
